"use strict";

require("core-js/modules/es6.array.map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _sliders = require("../../styles/sliders");

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

var _button = require("./button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default(props) {
  var settings = {
    arrows: true,
    autoplay: false,
    slidesToShow: props.slides || 3,
    slidesToScroll: 1,
    initialSlide: 0,
    infinite: false,
    adaptiveHeight: true,
    nextArrow: /*#__PURE__*/_react["default"].createElement(_button.CustomNextButton, null),
    prevArrow: /*#__PURE__*/_react["default"].createElement(_button.CustomPrevButton, null)
  };
  return /*#__PURE__*/_react["default"].createElement(_sliders.MainContainer, null, /*#__PURE__*/_react["default"].createElement(_sliders.SliderContainer, {
    slides: props.slides || 3
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], settings, props.children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_sliders.SliderChild, {
      key: index
    }, child);
  }))));
};

exports["default"] = _default;
module.exports = exports["default"];